/**
 * Map keys commonly used for navigation to their JavaScript codes
 * {@link https://keycode.info/}
 */
export const keys = {
  DOWN: 'ArrowDown',
  ESCAPE: 'Escape',
  ENTER: 'Enter',
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight',
  TAB: 'Tab',
  SPACE: 'Space',
  UP: 'ArrowUp'
}
